import DM from 'DM';
import Vue from 'vue';
import store from '../store/index.js';
import ProductDetailsStore from '../store/modules/product-details-store.js';
import LightboxComponent from '../components/lightbox/lightbox-component.vue';
import * as types from '../store/types.js';

import { addParameters, getQueryParameters } from '../utils/url.js';
import EventDelegate from '../utils/event-delegate.js';
import { SIZES } from '../utils/screen-sizes.js';

const PRODUCT_SELECTOR = '.js-lightbox';

const Lightbox = (() => {
    class Lightbox {

        constructor() {
            this.vm = this.createComponent();
            this.checkParameter();
            this.addEvents();
        }

        createComponent() {
            const el = document.createElement('div');
            document.body.appendChild(el);

            store.registerModule('productDetails', ProductDetailsStore);

            return new Vue({
                render: h => h(LightboxComponent),
                el,
                store
            });
        }

        handleClick(e) {
            const clickedElement = e.originalEvent.target;
            const showDetails = clickedElement.classList.contains('js-open-lightbox');
            const showCoupon = !!clickedElement.closest('.js-coupon-label');

            if (!showDetails && !showCoupon) {
                e.currentTarget.setAttribute('href', e.currentTarget.getAttribute('data-redirect'));
            } else {
                e.originalEvent.preventDefault();
                const id = parseInt(e.currentTarget.getAttribute('pid'));
                const shopId = e.currentTarget.getAttribute('data-shop-id');
                const url = addParameters(window.location.search, { pr: id });
                window.history.pushState(null, null, url);

                this.vm.$store.dispatch(types.PRODUCT_DETAILS_SHOW, { id, url });
                this.trackEvent('click_lightbox_tile', shopId);
            }
        }

        checkParameter() {
            const queryParameters = getQueryParameters(window.location.search);
            const pidFromQuery = queryParameters['pr'];

            if (pidFromQuery) {
                const locationPathName = window.location.pathname;
                const locationSearch = window.location.search;
                const locationHref = window.location.href;                
                delete queryParameters['pr'];

                this.vm.$store.dispatch(types.PRODUCT_DETAILS_SHOW, { id: parseInt(pidFromQuery) });
            }
        }

        handlePopstate() {
            const pidFromQuery = getQueryParameters(window.location.search)['pr'];
            const isLightboxOpened = !!this.vm.$store.getters.currentProductId;

            if (pidFromQuery) {
                this.vm.$store.dispatch(types.PRODUCT_DETAILS_SHOW, { id: parseInt(pidFromQuery) });
                this.trackEvent('history_change', 'open');
            } else if (isLightboxOpened) {
                this.vm.$store.dispatch(types.PRODUCT_DETAILS_HIDE);
                this.trackEvent('history_change', 'close');
            }
        }

        trackEvent(action, label) {
            const category = window.innerWidth >= SIZES.LARGE ? 'd_lightbox' : 'm_lightbox';
            DM.Utils.trackEvents(category, action, label);
        }

        addEvents() {
            window.addEventListener('popstate', this.handlePopstate.bind(this));
            if (DM.Config.isLightboxEnabled) {
                const delegate = new EventDelegate(document);
                delegate.on('click', PRODUCT_SELECTOR, this.handleClick.bind(this));
            }
        }
    }

    return new Lightbox();

})();

export default Lightbox;
